import { axiosPost } from '../ServiceBase.js';

/**
 * Validar orden api call
 * @returns
 */
export const getCambiarPassword = (data) => {
  return axiosPost('/v1/usuario/cambiar-password', data);
};
